import { Injectable } from "@angular/core";
import { DataService } from './DataServices/data.service';
import { ILang } from '../model/lang.interface';
import { BehaviorSubject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { AppService } from './app.service';
import {
    DEFAULT_LANG_SLUG,
    getStoredLangSlug,
    isLangChosenByUser,
    localeToSlug,
    storeAutoLangSlug,
    storeUserLangSlug,
} from './lang.storage';

@Injectable()
export class LangsRepository {
    public langs: ILang[] = [];
    public current: ILang | null = null;
    public ready: BehaviorSubject<boolean> = new BehaviorSubject(false);

    constructor(
        private dataService: DataService,
        private route: ActivatedRoute,
        private appService: AppService,
    ) {
        this.dataService.getLangs().subscribe(res => {
            this.langs = res;
            this.initCurrent();
            this.initCurrentSwitch();
            this.ready.next(true);
        });
    }

    public setDefault(): void {
        this.current = this.langs.find(l => l.slug === DEFAULT_LANG_SLUG) || this.langs[0];
        storeAutoLangSlug(this.current.slug);
    }

    public setCurrent(slug: string): void {
        // remove because UI issue apper
        // this.current = this.langs.find(l => l.slug === slug);
        storeUserLangSlug(slug);
        this.appService.showNetworkstatus(`language = ${this.current.slug}`);
        window.location.reload();
    }

    public applyServerLocale(locale: string | null | undefined): void {
        const slug = localeToSlug(locale);
        if (!slug || isLangChosenByUser() || slug === getStoredLangSlug()) {
            return;
        }

        this.ready.pipe(filter(isReady => isReady), take(1)).subscribe(() => {
            if (!this.langs.some(l => l.slug === slug) || slug === getStoredLangSlug()) {
                return;
            }

            storeAutoLangSlug(slug);
            window.location.reload();
        });
    }

    private initCurrent(): void {
        var currentLangSlug = getStoredLangSlug();

        if (currentLangSlug) {
            let currentLang: ILang | null = this.langs.find(l => l.slug === currentLangSlug) || null;

            if (currentLang) {
                this.current = currentLang;
            } else {
                this.setDefault();
            }
        } else {
            this.setDefault();
        }
        document.documentElement.lang = this.current.slug;
        document.dir = this.current.dir;
    }

    private initCurrentSwitch(): void {
        this.route.fragment.subscribe(hash => {
            if (hash) {
                let hashParts: string[] = hash.split("=");

                if (hashParts.length === 2 && hashParts[0] === "lang") {
                    let langSlug = hashParts[1];
                    let currentLang: ILang | null = this.langs.find(l => l.slug === langSlug) || null;

                    if (currentLang) {
                        this.current = currentLang;
                        storeUserLangSlug(this.current.slug);
                        this.appService.showNetworkstatus(`language = ${langSlug}`);
                        window.location.href = "/";
                    }
                }
            }
        });
    }
}
